import { useEffect } from 'react'
import { Modal, Form } from 'antd'
import { Loader } from '@/components'

export const ModalConfirm = ({
  visible,
  onSubmit,
  onCancel,
  title,
  okText,
  cancelText,
  initialValues,
  formItems,
  loading = false,
  isForm = true,
  okButtonProps = { size: 'large' },
  cancelButtonProps = { size: 'large' },
  footer,
  width,
  onChangeForm,
  className = "",
  ...props
}) => {
  const [form] = Form.useForm()
  const footerList = { footer }
  useEffect(() => {
    form.setFieldsValue(initialValues)
  }, [initialValues])
  return (
    <Modal
      className={`common-modal ${className}`}
      open={visible}
      title={title}
      okText={okText || 'Save'}
      cancelText={cancelText || 'Cancel'}
      onCancel={onCancel}
      destroyOnClose={true}
      width={width || 600}
      okButtonProps={okButtonProps}
      cancelButtonProps={cancelButtonProps}
      {...footerList}
      onOk={() => {
        return isForm
          ? form
            .validateFields()
            .then((values) => {
              form.resetFields()
              onSubmit(values)
            })
            .catch((info) => {
            })
          : onSubmit()
      }}
    >
      <Loader loading={loading}>
        {isForm ? (
          <Form
            form={form}
            layout="vertical"
            name="form_in_modal"
            initialValues={initialValues}
            onValuesChange={onChangeForm}
            preserve={false}
            requiredMark={false}
            {...props}
          >
            {formItems(form)}
          </Form>
        ) : (
          <>{formItems()}</>
        )}
      </Loader>
    </Modal>
  )
}

export const ConfirmationDialog = (props) => {
  Modal.confirm({
    title: 'Confirm',
    okButtonProps: { danger: true },
    ...props,
  })
}
